import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import selectors from './selectors';

const options = {
  name: 'tasks',
  baseType: 'TASKS',
  apiEndpoint: 'tasks'
};

const operations = createMetadataAPIOperations(options);

export { operations, selectors };
export default createMetadataAPIReducer(options);
